/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface TrajectoryActionPlannerPhotoStatus {
}

export enum TrajectoryActionPlannerPhotoStatus_Enum {
  UNKNOWN = 0,
  SUCCESS = 1,
  SUCCESS_LIMITS_EXCEEDED = 2,
  SUCCESS_BEST_EFFORT_PHOTO = 3,
  FAILURE_ISP_ERROR = 4,
  FAILURE_GAVE_UP_REACHING_WAYPOINT = 5,
  FAILURE_ISP_TIMEOUT = 6,
  UNRECOGNIZED = -1,
}

export function trajectoryActionPlannerPhotoStatus_EnumFromJSON(object: any): TrajectoryActionPlannerPhotoStatus_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return TrajectoryActionPlannerPhotoStatus_Enum.UNKNOWN;
    case 1:
    case "SUCCESS":
      return TrajectoryActionPlannerPhotoStatus_Enum.SUCCESS;
    case 2:
    case "SUCCESS_LIMITS_EXCEEDED":
      return TrajectoryActionPlannerPhotoStatus_Enum.SUCCESS_LIMITS_EXCEEDED;
    case 3:
    case "SUCCESS_BEST_EFFORT_PHOTO":
      return TrajectoryActionPlannerPhotoStatus_Enum.SUCCESS_BEST_EFFORT_PHOTO;
    case 4:
    case "FAILURE_ISP_ERROR":
      return TrajectoryActionPlannerPhotoStatus_Enum.FAILURE_ISP_ERROR;
    case 5:
    case "FAILURE_GAVE_UP_REACHING_WAYPOINT":
      return TrajectoryActionPlannerPhotoStatus_Enum.FAILURE_GAVE_UP_REACHING_WAYPOINT;
    case 6:
    case "FAILURE_ISP_TIMEOUT":
      return TrajectoryActionPlannerPhotoStatus_Enum.FAILURE_ISP_TIMEOUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TrajectoryActionPlannerPhotoStatus_Enum.UNRECOGNIZED;
  }
}

export function trajectoryActionPlannerPhotoStatus_EnumToJSON(object: TrajectoryActionPlannerPhotoStatus_Enum): string {
  switch (object) {
    case TrajectoryActionPlannerPhotoStatus_Enum.UNKNOWN:
      return "UNKNOWN";
    case TrajectoryActionPlannerPhotoStatus_Enum.SUCCESS:
      return "SUCCESS";
    case TrajectoryActionPlannerPhotoStatus_Enum.SUCCESS_LIMITS_EXCEEDED:
      return "SUCCESS_LIMITS_EXCEEDED";
    case TrajectoryActionPlannerPhotoStatus_Enum.SUCCESS_BEST_EFFORT_PHOTO:
      return "SUCCESS_BEST_EFFORT_PHOTO";
    case TrajectoryActionPlannerPhotoStatus_Enum.FAILURE_ISP_ERROR:
      return "FAILURE_ISP_ERROR";
    case TrajectoryActionPlannerPhotoStatus_Enum.FAILURE_GAVE_UP_REACHING_WAYPOINT:
      return "FAILURE_GAVE_UP_REACHING_WAYPOINT";
    case TrajectoryActionPlannerPhotoStatus_Enum.FAILURE_ISP_TIMEOUT:
      return "FAILURE_ISP_TIMEOUT";
    case TrajectoryActionPlannerPhotoStatus_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTrajectoryActionPlannerPhotoStatus(): TrajectoryActionPlannerPhotoStatus {
  return {};
}

export const TrajectoryActionPlannerPhotoStatus = {
  encode(_: TrajectoryActionPlannerPhotoStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryActionPlannerPhotoStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryActionPlannerPhotoStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrajectoryActionPlannerPhotoStatus {
    return {};
  },

  toJSON(_: TrajectoryActionPlannerPhotoStatus): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryActionPlannerPhotoStatus>, I>>(
    base?: I,
  ): TrajectoryActionPlannerPhotoStatus {
    return TrajectoryActionPlannerPhotoStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryActionPlannerPhotoStatus>, I>>(
    _: I,
  ): TrajectoryActionPlannerPhotoStatus {
    const message = createBaseTrajectoryActionPlannerPhotoStatus();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
